import API from '@scale/frontend-lib/dashboard-api';
import { useQuery } from 'react-query';

export const useInstructionTaskData = (
  taskId: string,
  readOnly: boolean,
  projectTemplateId?: string,
  notRequiredInstructionExample?: boolean,
) => {
  const cacheMinutes = 5;
  const resp = useQuery(
    ['use-instruction-task-data', taskId],
    () =>
      API.selfserve.fetchInstructionExample({
        task: taskId,
        projectTemplateId,
        notRequiredInstructionExample,
      }),
    readOnly ? { cacheTime: 1000 * 60 * cacheMinutes } : { cacheTime: 0 },
  );
  return resp;
};
